// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取过磅列表
export function getHistoryList(data) {
  const url = global.requestUrl + '/inventoryRecord/queryAll?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&materialName=' + data.material
  return axios.get(url)
}

